import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { elevation, textEllipsis, typo } from '@mathflat/common/style'
import mediaQuery from '@mathflat/common/style/mediaQuery'

export const accordionCardBottom = css`
  border: 1px solid var(--Colors-Gray-400);
  border-radius: 0 0 var(--Radius-200) var(--Radius-200);
`

const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    > .accordion-wrap {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .search-wrapper {
      display: flex;
      border-right: 1px solid var(--Colors-Gray-400);
      padding: 16px;
      background-color: white;
    }
  `,

  accordion: css`
    flex: auto;
    height: 0;
    border: 1px solid var(--Colors-Gray-400);
    border-left: none;
    border-bottom: none;
    .empty-student-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: var(--Colors-Gray-700);
      ${typo.body02}
      text-align: center;
    }
  `,
  itemContent: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    background-color: white;

    > * {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 56px;
      padding-left: 38px;
      padding-right: 15.5px;
      border-bottom: 1px solid var(--Colors-Gray-200);
      visibility: hidden;
      transition: visibility 0.28s;
      cursor: pointer;

      &:first-of-type {
        border-top: 1px solid var(--Colors-Gray-200);
      }

      &:last-child {
        border: none;
      }

      .clicked {
        color: var(--Colors-Sky-400);
        font-weight: 700;

        > svg > path {
          fill: var(--Colors-Sky-400);
        }
      }

      > div {
        display: flex;

        .people {
          margin-left: 7px;
        }
      }

      button {
        ${typo.caption01}
      }
    }
  `,
  itemContentOpen: css`
    > * {
      visibility: visible;
    }
  `,
  tab: css`
    display: flex;
    height: 40px;
  `,
  label: css`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100%;
    border: 1px solid var(--Colors-Gray-400);
    border-left: none;
    background-color: var(--Colors-Gray-100);
    color: var(--Colors-Gray-600);
    cursor: pointer;
    &.active {
      border-bottom: none;
      background-color: white;
      color: var(--Colors-Gray-900);
    }
  `,
  lessonStudentGroup: css`
    flex: 1;
  `,
  accordionWrap: css`
    display: flex;
    position: relative;
    flex: 0 0 180px;
    flex-direction: column;
    height: 100%;
    transition: all 0.3s ease-in-out;

    &.floated {
      flex: 0;
    }

    .lesson-accordion-container {
      position: absolute;
      top: 0;
      left: 0;
      min-width: 180px;
      height: 100%;
      overflow: hidden;
      transition: box-shadow 0s 0s;

      z-index: 19;
    }

    .lesson-accordion-contents {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      visibility: visible;
      transition: all 0.3s ease-in-out;
      transform: translateX(0);
    }

    &.floated {
      display: flex;
      width: 0;
      flex: 0 0 0px;
      margin-right: 0;

      .lesson-accordion-container {
        width: 180px;
        visibility: hidden;
        box-shadow:
          0px 4px 8px rgba(41, 42, 43, 0),
          0px 12px 16px rgba(41, 42, 43, 0);
      }

      .lesson-accordion-contents {
        visibility: hidden;
        transform: translateX(-100%);
        z-index: 10;
      }

      &.open {
        .lesson-accordion-container {
          visibility: visible;
          transition: box-shadow 0.22s 0.22s;
          ${elevation.$02};
        }

        .lesson-accordion-contents {
          width: 100%;
          visibility: visible;
          transform: translateX(0);
        }
      }
    }

    ${mediaQuery.large} {
      &.floatable {
        display: flex;
        width: 0;
        flex: 0 0 0px;
        margin-right: 0;

        .lesson-accordion-container {
          width: 180px;
          visibility: hidden;
          box-shadow:
            0px 4px 8px rgba(41, 42, 43, 0),
            0px 12px 16px rgba(41, 42, 43, 0);
        }

        .lesson-accordion-contents {
          visibility: hidden;
          transform: translateX(-100%);
          z-index: 10;
        }

        &.open {
          .lesson-accordion-container {
            visibility: visible;
            transition: box-shadow 0.22s 0.22s;
            ${elevation.$02};
          }

          .lesson-accordion-contents {
            width: 100%;
            visibility: visible;
            transform: translateX(0);
          }
        }
      }
    }
  `,
  accordionOpenButton: css`
    position: absolute;
    display: none;
    align-items: center;
    width: 112px;
    height: 28px;
    padding: 0 12px;
    border-radius: var(--Radius-300);
    background-color: var(--Colors-Gray-100);

    &.floated {
      display: flex;
    }

    ${mediaQuery.large} {
      display: flex;
    }

    .student-state {
      min-width: 7px;
      height: 7px;
      border-radius: var(--Radius-Circle);
      background-color: var(--Colors-Gray-400);

      &.enter {
        background-color: var(--Colors-Sky-400);
      }

      &.quit {
        background-color: var(--Colors-Gray-800);
      }
    }

    .chevron_double_right {
      margin-left: auto;
      min-width: 10px;

      &.show {
        transform: rotate(180deg);
      }
    }

    .button-label {
      display: flex;

      p {
        ${typo.caption01}
        margin: 0 6px;
        margin-top: 2px;
        color: var(--Colors-Gray-800);
      }
    }
  `,
  groupItem: css`
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 0 16px;
    height: 48px;
    width: 100%;

    border-bottom: 1px solid var(--Colors-Gray-300);
    background-color: var(--Colors-Gray-100);
    transition: background-color 0.15s ease;

    &:hover {
      background-color: var(--Colors-Gray-200);
    }

    .group-name {
      color: var(--Colors-Gray-900);
    }

    .group-count {
      margin-left: auto;
      color: var(--Colors-Gray-700);
      ${typo.caption01};
    }

    .group-arrow {
      margin-right: 2px;
    }
  `,
  accordionFilter: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 16px 16px;
    border-right: 1px solid var(--Colors-Gray-400);
    background-color: white;

    button {
      ${typo.caption01};
    }

    label.with-text {
      margin-left: 4px;
    }
  `,
  syncButton: css`
    padding: 0 16px 16px 16px;
    border-left: 1px solid var(--Colors-Gray-400);
    border-right: 1px solid var(--Colors-Gray-400);
    background-color: white;
  `,
  accordionFilterGuest: css`
    button {
      flex: 1;
      margin-right: 0;
    }
  `,
  accordionHeader: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid var(--Colors-Gray-400);
    background-color: white;
    gap: 8px;
    padding: 16px;
    ${mediaQuery.large} {
      padding: 16px;
      background-color: #fff;
    }

    &.guest {
      gap: 12px;
      border-bottom: 1px solid var(--Colors-Gray-400);
    }

    &.guest.seamless {
      border-bottom: none;
    }
  `,
  studentMember: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 56px;
    width: 100%;
    border-bottom: 1px solid var(--Colors-Gray-300);
    background-color: white;
    transition: background-color 0.15s ease;

    &:not(.active):hover {
      background-color: var(--Colors-Gray-100);
    }

    .row-label {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-right: auto;
      padding-left: 24px;
    }

    .attendance-button {
      ${typo.caption01};
    }

    .student-name {
      margin-left: 24px;

      /* 출결 버튼이 없어 이름이 풀폭일 때는 좌우 24px inset (margin 대신 padding) */
      &.full-width {
        margin-left: 0;
        padding: 0 24px;
      }
    }

    .guest-name-id {
      display: flex;
      align-items: center;
      gap: 4px;
      flex: 1;
      min-width: 0;
      padding: 0 24px;
    }

    .guest-name {
      flex: 0 0 auto;
      min-width: 0;
      max-width: 66px;
      ${typo.body02};
      color: var(--Colors-Gray-900);
      ${textEllipsis(1)};
    }

    .creverse-id {
      flex: 0 1 auto;
      min-width: 0;
      ${typo.body02};
      font-weight: 400;
      color: var(--Colors-Gray-500);
      ${textEllipsis(1)};
    }

    &.active {
      background-color: var(--Colors-Sky-50);
      color: var(--Colors-Sky-400);
      font-weight: 700;

      .guest-name {
        color: var(--Colors-Sky-400);
      }

      .creverse-id {
        color: var(--Colors-Blue-300);
      }

      svg path {
        fill: var(--Colors-Sky-400);
      }

      &:hover {
        background-color: var(--Colors-Sky-100);
      }
    }
  `,
}

export default S
